import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Dimensions, ImageCroppedEvent, ImageTransform } from '../../interfaces';
import { base64ToFile } from '../../utils/blob.utils';
import { ImageCropperComponent } from '../image-cropper/image-cropper.component';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'lib-control-image-cropper',
    templateUrl: './control-image-cropper.component.html',
    styleUrls: ['./control-image-cropper.component.scss'],
    imports: [ImageCropperComponent, TranslatePipe]
})
export class ControlImageCropperComponent implements OnInit {

    @Input() imageChangedEvent: any = '';
    @Input() imageURL: string;
    @Input() imageBase64: string;
    @Input() imageFile: File;
    @Input() showBtnUplod = true;

    @Output() imageCroppedB64 = new EventEmitter<ImageCroppedEvent>();


    croppedImage: any = '';
    canvasRotation = 0;
    rotation = 0;
    scale = 1;
    showCropper = false;
    containWithinAspectRatio = false;
    transform: ImageTransform = {};

    ngOnInit(): void {
    }

    fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
    }

    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;
        console.log(event, base64ToFile(event.base64));
        this.imageCroppedB64.emit(event);
    }

    imageLoaded() {
        this.showCropper = true;
        console.log('Image loaded');
    }

    cropperReady(sourceImageDimensions: Dimensions) {
        console.log('Cropper ready', sourceImageDimensions);
    }

    loadImageFailed() {
        console.log('Load failed');
    }

    rotateLeft() {
        this.canvasRotation--;
        this.flipAfterRotate();
    }

    rotateRight() {
        this.canvasRotation++;
        this.flipAfterRotate();
    }

    private flipAfterRotate() {
        const flippedH = this.transform.flipH;
        const flippedV = this.transform.flipV;
        this.transform = {
            ...this.transform,
            flipH: flippedV,
            flipV: flippedH
        };
    }


    flipHorizontal() {
        this.transform = {
            ...this.transform,
            flipH: !this.transform.flipH
        };
    }

    flipVertical() {
        this.transform = {
            ...this.transform,
            flipV: !this.transform.flipV
        };
    }

    resetImage() {
        this.scale = 1;
        this.rotation = 0;
        this.canvasRotation = 0;
        this.transform = {};
    }

    zoomOut() {
        this.scale -= .1;
        this.transform = {
            ...this.transform,
            scale: this.scale
        };
    }

    zoomIn() {
        this.scale += .1;
        this.transform = {
            ...this.transform,
            scale: this.scale
        };
    }

    toggleContainWithinAspectRatio() {
        this.containWithinAspectRatio = !this.containWithinAspectRatio;
    }

    updateRotation() {
        this.transform = {
            ...this.transform,
            rotate: this.rotation
        };
    }

}
